module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lBSnj"))).then(() => parcelRequire('2KbAe'));